export const passwordList = [
    // {name:'huidig', label:'Huidig ​​wachtwoord', value:'', error: false, eye:false },
    {name:'nieuw', label:'Nieuw paswoord', value:'', error: false, eye:false },
    {name:'bevestig', label:'Bevestig wachtwoord', value:'', error: false, eye:false },
]